import { newLogoReachOk64 } from 'reports/base64Images';
import theme from 'source/theme';
import { ERC, PC, PROC, SU } from 'utils/constants/descriptorTypes';
import { shortDate } from 'utils/helperFunctions/dateFormat';

const rowGenerator_SU_PC_ERC_PROC = (
  product, scenario, descriptors, conditions, scenarioDescriptors, scenarioDescriptorConditions, units
) => {

  const filteredSD = scenarioDescriptors.filter(fsd => fsd.scenario_id === scenario.id);
  const filteredSDIds = filteredSD.map(sd => sd.id);

  const filteredSDC = scenarioDescriptorConditions.filter(sdc =>
    filteredSDIds.includes(sdc.scenario_descriptor_id)
  );

  const PCDescriptorIds = descriptors.data.filter(v => v.descriptor_type_id === PC).map(obj => obj.id);
  const SUDescriptorIds = descriptors.data.filter(v => v.descriptor_type_id === SU).map(obj => obj.id);
  const ERCdescriptorIds = descriptors.data.filter(v => v.descriptor_type_id === ERC).map(obj => obj.id);
  const PROCdescriptorIds = descriptors.data.filter(v => v.descriptor_type_id === PROC).map(obj => obj.id);

  const PC_SD = filteredSD.filter(sd => PCDescriptorIds.includes(sd.descriptor_id));
  const SU_SD = filteredSD.filter(sd => SUDescriptorIds.includes(sd.descriptor_id));
  const ERC_SD = filteredSD.filter(sd => ERCdescriptorIds.includes(sd.descriptor_id));
  const PROC_SD = filteredSD.filter(sd => PROCdescriptorIds.includes(sd.descriptor_id));

  const PC_D_ToRender = PC_SD.map(sd => descriptors.models[sd.descriptor_id]);
  const SU_D_ToRender = SU_SD.map(sd => descriptors.models[sd.descriptor_id]);
  const ERC_D_ToRender = ERC_SD.map(sd => descriptors.models[sd.descriptor_id]);
  const PROC_D_ToRender = PROC_SD.map(sd => descriptors.models[sd.descriptor_id]);


  const ERC_SDC = ERC_SD.map(sd => filteredSDC.filter(sdc => sdc.scenario_descriptor_id === sd.id));
  const ERC_C_ToRender = ERC_SDC.map(sdcArray => sdcArray.map(sdc =>
      ({
        ...conditions.models[sdc.condition_id],
        value: sdc.value
      })
    )
  );

  const PROC_SDC = PROC_SD.map(sd => filteredSDC.filter(sdc => sdc.scenario_descriptor_id === sd.id));
  const PROC_C_ToRender = PROC_SDC.map(sdcArray => sdcArray.map(sdc =>
      ({
        ...conditions.models[sdc.condition_id],
        value: sdc.value
      })
    )
  );

  const renderDescriptorsWithoutConditions = descriptors =>
    descriptors.map(d =>
      [
        d.code,
        { text: d.description, colSpan: 3 },
        '',
        ''
      ]
    );

  const renderDescriptorsWithConditions = (descriptors, conditions, units) => {
    const dataToRender = [];
    descriptors.forEach((d, index) => {
      dataToRender.push([
        { text: d.code, rowSpan: conditions[index].length + 1, bold: true },
        { text: d.description, colSpan: 3, bold: true },
        '',
        ''
      ]);
      conditions[index].forEach(c =>
        dataToRender.push([
          '',
          { text: c.value ? c.value : '', border: [false, false, false, false] },
          { text: c.unit_id ? units[c.unit_id].name : '', border: [false, false, false, false] },
          { text: c.name, border: [false, false, false, false] }
        ])
      );
    });
    return dataToRender;
  };

  return [
    ...renderDescriptorsWithoutConditions(PC_D_ToRender),
    ...renderDescriptorsWithoutConditions(SU_D_ToRender),
    ...renderDescriptorsWithConditions(ERC_D_ToRender, ERC_C_ToRender, units),
    ...renderDescriptorsWithConditions(PROC_D_ToRender, PROC_C_ToRender, units)
  ];
};

const rowGenerator_SU_PC_ERC_PROC_all_scenarios = (
  product, scenarios, descriptors, conditions, scenarioDescriptors, scenarioDescriptorConditions, units, lcsById
) => {
  let rows = [];

  scenarios.forEach(scenario => {
    const filteredScenarioDescriptors = scenarioDescriptors.filter(sd => sd.scenario_id === scenario.id);

    rows = [
      ...rows,
      [
        { text: scenario.code, fillColor: theme.palette.primary.light },
        { text: lcsById[parseInt(scenario.lcs_id)].description, colSpan: 2, fillColor: theme.palette.primary.light },
        '',
        { text: scenario.designation, fillColor: theme.palette.primary.light }
      ],
      ...rowGenerator_SU_PC_ERC_PROC(
        product,
        scenario,
        descriptors,
        conditions,
        filteredScenarioDescriptors,
        scenarioDescriptorConditions,
        units
      )
    ];
  });

  return rows;
};

const dd = (
  product, descriptors, conditions, scenarios, scenarioDescriptors,
  scenarioDescriptorConditions, units, lcsById
) => {

  return {
    pageSize: 'A4',
    pageMargins: [40, 60, 40, 40],

    footer: function (currentPage, pageCount) {
      return {
        text: `${shortDate(new Date())} - ${currentPage.toString()} de ${pageCount}`,
        alignment: 'right',
        relativePosition: { x: -15, y: 20 },
        fontSize: 7
      };
    },
    header: function (currentPage, pageCount, pageSize) {
      return [
        {
          image: newLogoReachOk64,
          width: 50,
          relativePosition: { x: 20, y: 10 }
        }
      ];
    },
    content: [
      {
        style: 'header',
        text: `${product.code} - ${product.name}`
      },
      {
        style: 'header',
        text: 'Todos os Cenários'
      },
      {
        style: 'tableExample',
        layout: 'lightHorizontalLines',
        table: {
          headerRows: 1,
          widths: [50, 25, 75, '*'],
          body: [
            ...rowGenerator_SU_PC_ERC_PROC_all_scenarios(
              product,
              scenarios,
              descriptors,
              conditions,
              scenarioDescriptors,
              scenarioDescriptorConditions,
              units,
              lcsById
            )
          ]
        }
      }
    ],
    styles: {
      header: {
        color: theme.palette.primary.main,
        fontSize: 16,
        bold: true,
        alignment: 'center'
      },
      tableExample: {
        margin: [0, 15, 0, 0],
        fontSize: 8
      }
    }
  };
};

export default dd;
